import i18n from "i18n";

// REF-5549 (BE REF-5446): teams/payments error responses carry a stable, locale-independent
// `reason_code` inside `responseData` (e.g. "already_in_team", "allocation_below_spent"). The BE
// `responseMessage`/`response_message` is an English fallback only — never branch on its text.
//
// `getReasonCode` reads the code off a rejected error (teams 4xx/409 reject via the HttpClient
// teams-admin exemption). `reasonErrorText` resolves the user-facing string from a rejected error.
//
// `reasonCodeText` is the shared primitive both the teams path (here) and the payments path
// (`resolvePaymentMessage` in usePaymentActionHandler) resolve through, so the `errors:<code>`
// rule lives in exactly one place: a localized `errors:<code>` (with optional ICU vars) when the
// code is mapped, else the caller's already-resolved fallback message.
export const getReasonCode = (err: any): string | undefined => err?.response?.data?.responseData?.reason_code;

export const reasonCodeText = (code: string | undefined, fallback: string, vars?: Record<string, string | number>): string => {
  if (code && i18n.exists(`errors:${code}`)) return i18n.t(`errors:${code}`, vars ?? {}) as string;

  return fallback;
};

export const reasonErrorText = (err: any, fallback: string, vars?: Record<string, string | number>): string => {
  const data = err?.response?.data;
  const code = data?.responseData?.reason_code as string | undefined;

  return reasonCodeText(code, data?.responseMessage || data?.responseData?.response_message || fallback, vars);
};

// REF-5028: newer BE endpoints (project sharing, set-password) name the same kind of stable
// machine key `error_code` instead of `reason_code`. Same rule, same catalog — resolved through
// `reasonCodeText` so the `errors:<code>` lookup keeps living in exactly one place.
export const getErrorCode = (err: any): string | undefined => err?.response?.data?.responseData?.error_code;

export const errorCodeText = (err: any, fallback: string, vars?: Record<string, string | number>): string => {
  const data = err?.response?.data;

  return reasonCodeText(getErrorCode(err), data?.responseData?.message || data?.responseMessage || fallback, vars);
};
